import type RibbonVersionManager from "./ribbonVersionManager";
import { type MailRibbonControlId, type MailRibbonGroupId } from "owa-ribbon-ids/lib/mailRibbonId";

/**
 * This is the Ribbon Version Manager for OWA Mail Ribbon.
 * For information on how to use and detailed examples, please see https://aka.ms/OWARibbonVersioning.
 * This is the mechanism that allows new changes in the Ribbon to be reflected in a user's customized ribbon,
 * without simultaneously blowing away all of their changes.
 *
 * Note: When adding to this array, be sure to update @see {CURRENT_RIBBON_VERSION} in @see {defaultConfig}.
 *
 * Please start each entry with `// Version #: <Explain what has changed.>`
 *
 * The version manager will have its versions older than 6 months pruned every now and then to help alleviate
 * the possible infinitely-growing bundle size of constant updates.
 */
export const mailRibbonVersionManager: RibbonVersionManager[] = [
    {
        oldVersioningPastSixMonthLimit: true,
        // Version 1: Adds several new view settings groups to the view tab.
        // addGroup: [
        //     {
        //         tabVariableName: 'viewTab',
        //         groupDefinition: {
        //             groupId: MailRibbonGroupId.Group_View_Settings,
        //             groupName: undefined,
        //             controlIds: [MailRibbonControlId.ViewSettings],
        //             hasOwnOverflow: false,
        //         },
        //     },
        //     {
        //         tabVariableName: 'viewTab',
        //         groupDefinition: {
        //             groupId: MailRibbonGroupId.Group_View_Messages,
        //             groupName: undefined,
        //             controlIds: [
        //                 MailRibbonControlId.Conversations,
        //                 MailRibbonControlId.MessagePreview,
        //             ],
        //             hasOwnOverflow: false,
        //         },
        //     },
        //     {
        //         tabVariableName: 'viewTab',
        //         groupDefinition: {
        //             groupId: MailRibbonGroupId.Group_View_Layout,
        //             groupName: undefined,
        //             controlIds: [MailRibbonControlId.Layout, MailRibbonControlId.Density],
        //             hasOwnOverflow: false,
        //         },
        //     },
        // ],
        // updateGroupOrdering: [
        //     {
        //         tabVariableName: 'viewTab',
        //         newStaticGroupIdOrdering: [
        //             MailRibbonGroupId.Group_View_Settings,
        //             MailRibbonGroupId.Group_View_Messages,
        //             MailRibbonGroupId.Group_View_Layout,
        //             MailRibbonGroupId.Group_ImmersiveReader,
        //             MailRibbonGroupId.Group_Print,
        //             MailRibbonGroupId.Group_RibbonCustomizer,
        //         ],
        //     },
        // ],
    },
    {
        oldVersioningPastSixMonthLimit: true,
        // Version 2: Adds PME group to home tab.
        // addGroup: [
        //     {
        //         tabVariableName: 'homeTab',
        //         groupDefinition: {
        //             groupId: MailRibbonGroupId.Group_PlayMyEmails_DEPRECATED,
        //             groupName: undefined,
        //             controlIds: [MailRibbonControlId.PlayMyEmails_DEPRECATED],
        //             hasOwnOverflow: false,
        //         },
        //     },
        // ],
        // updateGroupOrdering: [
        //     {
        //         tabVariableName: 'homeTab',
        //         newStaticGroupIdOrdering: [
        //             MailRibbonGroupId.Group_ToggleLeftPane_DEPRECATED,
        //             MailRibbonGroupId.Group_New,
        //             MailRibbonGroupId.Group_Delete,
        //             MailRibbonGroupId.Group_Respond,
        //             MailRibbonGroupId.Group_QuickSteps,
        //             MailRibbonGroupId.Group_Move,
        //             MailRibbonGroupId.Group_Tags,
        //             MailRibbonGroupId.Group_Find,
        //             MailRibbonGroupId.Group_Speech_DEPRECATED,
        //             MailRibbonGroupId.Group_Undo,
        //             MailRibbonGroupId.Group_AddIns,
        //             MailRibbonGroupId.Group_PlayMyEmails_DEPRECATED,
        //             MailRibbonGroupId.Group_Insights_DEPRECATED,
        //             MailRibbonGroupId.Group_Protection_DEPRECATED,
        //         ],
        //     },
        // ],
    },
    {
        oldVersioningPastSixMonthLimit: true,
        // Version 3: Remove the controls conversations and message preview from the view tab and replace them with messages dropdown.
        // removeControl: [
        //     {
        //         tabVariableName: 'viewTab',
        //         controlId: MailRibbonControlId.Conversations,
        //     },
        //     {
        //         tabVariableName: 'viewTab',
        //         controlId: MailRibbonControlId.MessagePreview,
        //     },
        // ],
        // addControl: [
        //     {
        //         tabVariableName: 'viewTab',
        //         groupId: MailRibbonGroupId.Group_View_Messages,
        //         controlId: MailRibbonControlId.Messages,
        //     },
        // ],
    },
    {
        oldVersioningPastSixMonthLimit: true,
        // Version 4: adds the quick steps control
        // addControl: [
        //     {
        //         tabVariableName: 'homeTab',
        //         groupId: MailRibbonGroupId.Group_Move_and_Delete,
        //         controlId: MailRibbonControlId.QuickStepsGallery,
        //     },
        // ],
        // addControlToOverflow: [
        //     {
        //         tabVariableName: 'homeTab',
        //         controlId: MailRibbonControlId.QuickStepsGallery,
        //     },
        // ],
    },
    
    {
        oldVersioningPastSixMonthLimit: true,
        // Version 5: Removes the Phishing Control
        // removeControl: [
        //     {
        //         tabVariableName: 'homeTab',
        //         controlId: MailRibbonControlId.Phishing,
        //     },
        // ],
    },
    
    {
        oldVersioningPastSixMonthLimit: true,
        // Version 6: Adds ReportSplit and BlockSplit controls
        // addControl: [
        //     {
        //         tabVariableName: 'homeTab',
        //         groupId: MailRibbonGroupId.Group_Move_and_Delete,
        //         controlId: MailRibbonControlId.ReportSplit,
        //     },
        //     {
        //         tabVariableName: 'homeTab',
        //         groupId: MailRibbonGroupId.Group_Move_and_Delete,
        //         controlId: MailRibbonControlId.BlockSplit,
        //     },
        // ],
        // addControlToOverflow: [
        //     {
        //         tabVariableName: 'homeTab',
        //         controlId: MailRibbonControlId.BlockSplit,
        //     },
        // ],
    },
    {
        oldVersioningPastSixMonthLimit: true,
        // Version 7: Move the quick steps control from the overflow+move group to tags group
        // removeControlFromOverflow: [
        //     {
        //         tabVariableName: 'homeTab',
        //         controlId: MailRibbonControlId.QuickStepsGallery,
        //     },
        // ],
        // removeControl: [
        //     {
        //         tabVariableName: 'homeTab',
        //         controlId: MailRibbonControlId.QuickStepsGallery,
        //     },
        // ],
        // addControl: [
        //     {
        //         tabVariableName: 'homeTab',
        //         groupId: MailRibbonGroupId.Group_Tags,
        //         controlId: MailRibbonControlId.QuickStepsGallery,
        //     },
        // ],
    },
    {
        oldVersioningPastSixMonthLimit: true,
        // Version 8: Removes the AddressBook Control
        // removeControl: [
        //     {
        //         tabVariableName: 'homeTab',
        //         controlId: MailRibbonControlId.AddressBook_DEPRECATED,
        //     },
        // ],
    },
    {
        oldVersioningPastSixMonthLimit: true,
        // Version 9: Add "View groups" to ribbon
        // addControl: [
        //     {
        //         tabVariableName: 'homeTab',
        //         groupId: MailRibbonGroupId.Group_Find,
        //         controlId: MailRibbonControlId.ViewGroupsPanel,
        //     },
        // ],
    },
    {
        oldVersioningPastSixMonthLimit: true,
        // Version 10: add comms copilot
        // addGroup: [
        //     {
        //         tabVariableName: 'homeTab',
        //         groupDefinition: {
        //             groupId: MailRibbonGroupId.Group_CommsCopilot,
        //             groupName: undefined,
        //             controlIds: [MailRibbonControlId.CommsCopilot],
        //             hasOwnOverflow: false,
        //         },
        //     },
        // ],
    },
    {
        oldVersioningPastSixMonthLimit: true,
        // Version 11: Remove JunkFlyout
        // removeControl: [
        //     {
        //         tabVariableName: 'homeTab',
        //         controlId: MailRibbonControlId.JunkFlyout_DEPRECATED,
        //     },
        // ],
    },
    {
        oldVersioningPastSixMonthLimit: true,
        // Version 12: Add "Respond combined options" to ribbon. Should be displayed only for consumers
        // addControl: [
        //     {
        //         tabVariableName: 'homeTab',
        //         groupId: MailRibbonGroupId.Group_Respond,
        //         controlId: MailRibbonControlId.RespondFlyout,
        //     },
        // ],
    },
    {
        oldVersioningPastSixMonthLimit: true,
        // Version 13: Removes the AddressBook Control again as we've been getting alerting on it
        // removeControl: [
        //     {
        //         tabVariableName: 'homeTab',
        //         controlId: MailRibbonControlId.AddressBook_DEPRECATED,
        //     },
        // ],
    },
    {
        oldVersioningPastSixMonthLimit: true,
        // Version 14: Add restore options to ribbon
        // addControl: [
        //     {
        //         tabVariableName: 'homeTab',
        //         groupId: MailRibbonGroupId.Group_Move_and_Delete,
        //         controlId: MailRibbonControlId.Restore,
        //     },
        //     {
        //         tabVariableName: 'homeTab',
        //         groupId: MailRibbonGroupId.Group_Move_and_Delete,
        //         controlId: MailRibbonControlId.RestoreAll,
        //     },
        // ],
    },
    {
        oldVersioningPastSixMonthLimit: true,
        // Version 15: Removing PME related code
        // removeGroup: [
        //     {
        //         tabVariableName: 'homeTab',
        //         groupId: MailRibbonGroupId.Group_PlayMyEmails_DEPRECATED,
        //     },
        // ],
    },
    {
        oldVersioningPastSixMonthLimit: true,
        // Version 16: ADO 208870, removing ToggleLeftPane from View Tab
        // removeControl: [
        //     {
        //         tabVariableName: 'viewTab',
        //         controlId: MailRibbonControlId.ToggleLeftPane_DEPRECATED,
        //     },
        // ],
    },
    {
        oldVersioningPastSixMonthLimit: true,
        // Version 17: add spam addins group
        // addGroup: [
        //     {
        //         tabVariableName: 'homeTab',
        //         groupDefinition: {
        //             groupId: MailRibbonGroupId.Group_SpamAddins,
        //             groupName: undefined,
        //             controlIds: [],
        //             hasOwnOverflow: false,
        //         },
        //     },
        // ],
    },
    {
        oldVersioningPastSixMonthLimit: true,
        // Version 18: move print from view to home and to reorder groups
        // removeGroup: [
        //     {
        //         tabVariableName: 'viewTab',
        //         groupId: MailRibbonGroupId.Group_Print,
        //     },
        // ],
        // addGroup: [
        //     {
        //         tabVariableName: 'homeTab',
        //         groupDefinition: {
        //             groupId: MailRibbonGroupId.Group_Print,
        //             groupName: undefined,
        //             controlIds: [MailRibbonControlId.Print],
        //             hasOwnOverflow: false,
        //         },
        //     },
        // ],
        // updateGroupOrdering: [
        //     {
        //         tabVariableName: 'viewTab',
        //         newStaticGroupIdOrdering: [
        //             MailRibbonGroupId.Group_View_Settings,
        //             MailRibbonGroupId.Group_View_Messages,
        //             MailRibbonGroupId.Group_View_Layout,
        //             MailRibbonGroupId.Group_ImmersiveReader,
        //             MailRibbonGroupId.Group_RibbonCustomizer,
        //         ],
        //     },
        //     {
        //         tabVariableName: 'homeTab',
        //         newStaticGroupIdOrdering: [
        //             MailRibbonGroupId.Group_ToggleLeftPane_DEPRECATED,
        //             MailRibbonGroupId.Group_New,
        //             MailRibbonGroupId.Group_Delete,
        //             MailRibbonGroupId.Group_Respond,
        //             MailRibbonGroupId.Group_QuickSteps,
        //             MailRibbonGroupId.Group_Move,
        //             MailRibbonGroupId.Group_Tags,
        //             MailRibbonGroupId.Group_Print,
        //             MailRibbonGroupId.Group_Find,
        //             MailRibbonGroupId.Group_Speech_DEPRECATED,
        //             MailRibbonGroupId.Group_Undo,
        //             MailRibbonGroupId.Group_AddIns,
        //             MailRibbonGroupId.Group_Insights_DEPRECATED,
        //             MailRibbonGroupId.Group_Protection_DEPRECATED,
        //         ],
        //     },
        // ],
    },
    {
        oldVersioningPastSixMonthLimit: true,
        // Version 19: Remove the print control from viewTab
        // removeControl: [
        //     {
        //         tabVariableName: 'viewTab',
        //         controlId: MailRibbonControlId.Print,
        //     },
        // ],
    },
    {
        oldVersioningPastSixMonthLimit: true,
        // Version 20: We've received lots of reports dating far back of controls popping up in view tab.
        // The exact reason unknown, however we'll start by versioning these controls out.
        // Suspect that for most users, this will be a no-op.
        // removeControl: removeExtraViewTabControls,
    },
    {
        oldVersioningPastSixMonthLimit: true,
        // Version 21: Add Message Recall to home tab.
        // addControl: [
        //     {
        //         tabVariableName: 'homeTab',
        //         groupId: MailRibbonGroupId.Group_Respond,
        //         controlId: MailRibbonControlId.MessageRecall,
        //     },
        // ],
        // addControlToOverflow: [
        //     {
        //         tabVariableName: 'homeTab',
        //         controlId: MailRibbonControlId.MessageRecall,
        //     },
        // ],
    },
    {
        oldVersioningPastSixMonthLimit: true,
        // Version 22: Add expand/collapse conversation and zoom buttons to viewTab
        // addControl: [
        //     {
        //         tabVariableName: 'viewTab',
        //         groupId: MailRibbonGroupId.Group_View_Messages,
        //         controlId: MailRibbonControlId.ExpandCollapseConversation,
        //     },
        //     {
        //         tabVariableName: 'viewTab',
        //         groupId: MailRibbonGroupId.Group_View_Messages,
        //         controlId: MailRibbonControlId.Zoom,
        //     },
        // ],
    },
    {
        oldVersioningPastSixMonthLimit: true,
        // Version 23: Remove left pane toggle from home tab
        // removeGroup: [
        //     {
        //         tabVariableName: 'homeTab',
        //         groupId: MailRibbonGroupId.Group_ToggleLeftPane_DEPRECATED,
        //     },
        // ],
        // removeControl: [
        //     {
        //         tabVariableName: 'homeTab',
        //         controlId: MailRibbonControlId.ToggleLeftPane_DEPRECATED,
        //     },
        // ],
    },
    {
        oldVersioningPastSixMonthLimit: true,
        // Version 24: add window group to view tab
        // addGroup: [
        //     {
        //         tabVariableName: 'viewTab',
        //         groupDefinition: {
        //             groupId: MailRibbonGroupId.Group_Window,
        //             groupName: undefined,
        //             controlIds: [MailRibbonControlId.RemindersWindow],
        //             hasOwnOverflow: false,
        //         },
        //     },
        // ],
        // updateGroupOrdering: [
        //     {
        //         tabVariableName: 'viewTab',
        //         newStaticGroupIdOrdering: [
        //             MailRibbonGroupId.Group_View_Settings,
        //             MailRibbonGroupId.Group_View_Messages,
        //             MailRibbonGroupId.Group_View_Layout,
        //             MailRibbonGroupId.Group_ImmersiveReader,
        //             MailRibbonGroupId.Group_Window,
        //             MailRibbonGroupId.Group_RibbonCustomizer,
        //         ],
        //     },
        // ],
    },
    {
        oldVersioningPastSixMonthLimit: true,
        // Version 25: Add CopilotReplyWithMeeting to home tab
        // addControl: [
        //     {
        //         tabVariableName: 'homeTab',
        //         groupId: MailRibbonGroupId.Group_Respond,
        //         controlId: MailRibbonControlId.CopilotReplyWithMeeting,
        //     },
        // ],
        
        // addControlToOverflow: [
        //     {
        //         tabVariableName: 'homeTab',
        //         controlId: MailRibbonControlId.CopilotReplyWithMeeting,
        //     },
        // ],
    },
    {
        oldVersioningPastSixMonthLimit: true,
        // Version 26: Add new "Tracking" group and Track Read Receipts to home tab.
        // addGroup: [
        //     {
        //         tabVariableName: 'homeTab',
        //         groupDefinition: {
        //             groupId: MailRibbonGroupId.Group_Tracking_Home,
        //             groupName: undefined,
        //             controlIds: [MailRibbonControlId.TrackReadReceipts],
        //             hasOwnOverflow: false,
        //         },
        //     },
        // ],
        // updateGroupOrdering: [
        //     {
        //         tabVariableName: 'homeTab',
        //         newStaticGroupIdOrdering: [
        //             MailRibbonGroupId.Group_Move_and_Delete,
        //             MailRibbonGroupId.Group_SpamAddins,
        //             MailRibbonGroupId.Group_Respond,
        //             MailRibbonGroupId.Group_Tracking_Home,
        //             MailRibbonGroupId.Group_Tags,
        //             MailRibbonGroupId.Group_Undo,
        //             MailRibbonGroupId.Group_Print,
        //             MailRibbonGroupId.Group_Find,
        //             MailRibbonGroupId.Group_AddIns,
        //             MailRibbonGroupId.Group_CommsCopilot,
        //         ],
        //     },
        // ],
        // addControl: [
        //     {
        //         tabVariableName: 'homeTab',
        //         groupId: MailRibbonGroupId.Group_Tracking_Home,
        //         controlId: MailRibbonControlId.TrackReadReceipts,
        //     },
        // ],
        // addControlToOverflow: [
        //     {
        //         tabVariableName: 'homeTab',
        //         controlId: MailRibbonControlId.TrackReadReceipts,
        //     },
        // ],
    },
    {
        oldVersioningPastSixMonthLimit: true,
        // Version 27: Adding CopilotReplyWithMeetingFlyout to home tab for enterprise users
        //     addControl: [
        //         {
        //             tabVariableName: 'homeTab',
        //             groupId: MailRibbonGroupId.Group_Respond,
        //             controlId: MailRibbonControlId.CopilotReplyWithMeetingFlyout,
        //         },
        //     ],
        //     addControlToOverflow: [
        //         {
        //             tabVariableName: 'homeTab',
        //             controlId: MailRibbonControlId.CopilotReplyWithMeetingFlyout,
        //         },
        //     ],
        //     removeControl: [
        //         {
        //             tabVariableName: 'homeTab',
        //             controlId: MailRibbonControlId.CopilotReplyWithMeeting,
        //         },
        //     ],
        //     removeControlFromOverflow: [
        //         {
        //             tabVariableName: 'homeTab',
        //             controlId: MailRibbonControlId.CopilotReplyWithMeeting,
        //         },
        //     ],
    },
    {
        oldVersioningPastSixMonthLimit: true,
        //     // Version 28: Add sync mail to viewTab
        //     addControl: [
        //         {
        //             tabVariableName: 'viewTab',
        //             groupId: MailRibbonGroupId.Group_View_Messages,
        //             controlId: MailRibbonControlId.SyncMailbox,
        //         },
        //     ],
    },
    {
        oldVersioningPastSixMonthLimit: true,
        //     // Version 29: Add chat around email to Teams chat group of home/read tab for enterprise users
        //     addGroup: [
        //         {
        //             tabVariableName: 'homeTab',
        //             groupDefinition: {
        //                 groupId: MailRibbonGroupId.Group_Teams_Chat,
        //                 groupName: undefined,
        //                 controlIds: [MailRibbonControlId.Teams_ChatAroundEmail],
        //                 hasOwnOverflow: false,
        //             },
        //         },
        //     ],
        //     updateGroupOrdering: [
        //         {
        //             tabVariableName: 'homeTab',
        //             newStaticGroupIdOrdering: [
        //                 MailRibbonGroupId.Group_Move_and_Delete,
        //                 MailRibbonGroupId.Group_SpamAddins,
        //                 MailRibbonGroupId.Group_Respond,
        //                 MailRibbonGroupId.Group_Teams_Chat,
        //                 MailRibbonGroupId.Group_Tracking_Home,
        //                 MailRibbonGroupId.Group_Tags,
        //                 MailRibbonGroupId.Group_Undo,
        //                 MailRibbonGroupId.Group_Print,
        //                 MailRibbonGroupId.Group_Find,
        //                 MailRibbonGroupId.Group_AddIns,
        //                 MailRibbonGroupId.Group_CommsCopilot,
        //             ],
        //         },
        //     ],
    },
    {
        oldVersioningPastSixMonthLimit: true,
        // Version 30: Add share to teams button to Teams chat group of home/read tab for enterprise users
        // addControl: [
        //     {
        //         tabVariableName: 'homeTab',
        //         groupId: MailRibbonGroupId.Group_Teams_Chat,
        //         controlId: MailRibbonControlId.Teams_ShareToTeamsChat,
        //     },
        // ],
    },
    {
        oldVersioningPastSixMonthLimit: true,
        // Version 31: Add Message Resend to home tab.
        // addControl: [
        //     {
        //         tabVariableName: 'homeTab',
        //         groupId: MailRibbonGroupId.Group_Respond,
        //         controlId: MailRibbonControlId.Resend,
        //     },
        // ],
        // addControlToOverflow: [
        //     {
        //         tabVariableName: 'homeTab',
        //         controlId: MailRibbonControlId.Resend,
        //     },
        // ],
    },
    {
        oldVersioningPastSixMonthLimit: true,
        // Version 32: Remove unused section.
        // removeControl: [
        //     {
        //         tabVariableName: 'homeTab',
        //         controlId: MailRibbonControlId.CommsCopilot,
        //     },
        // ],
        // removeGroup: [
        //     {
        //         tabVariableName: 'homeTab',
        //         groupId: MailRibbonGroupId.Group_CommsCopilot,
        //     },
        // ],
    },
    {
        oldVersioningPastSixMonthLimit: true,
        // Version 33: Adding CopilotReplyWithMeetingFlyout to Respond Group in Single Line Ribbon
        // removeControlFromOverflow: [
        //     {
        //         tabVariableName: 'homeTab',
        //         controlId: MailRibbonControlId.CopilotReplyWithMeetingFlyout,
        //     },
        // ],
    },
    {
        oldVersioningPastSixMonthLimit: true,
        // Version 34: Remove CopilotReplyWithMeetingFlyout and bring back CopilotReplyWithMeeting to home tab for enterprise users
        // removeControl: [
        //     {
        //         tabVariableName: 'homeTab',
        //         controlId: MailRibbonControlId.CopilotReplyWithMeetingFlyout,
        //     },
        // ],
        // removeControlFromOverflow: [
        //     {
        //         tabVariableName: 'homeTab',
        //         controlId: MailRibbonControlId.CopilotReplyWithMeetingFlyout,
        //     },
        // ],
        // addControl: [
        //     {
        //         tabVariableName: 'homeTab',
        //         groupId: MailRibbonGroupId.Group_Respond,
        //         controlId: MailRibbonControlId.CopilotReplyWithMeeting,
        //     },
        // ],
        // addControlToOverflow: [
        //     {
        //         tabVariableName: 'homeTab',
        //         controlId: MailRibbonControlId.CopilotReplyWithMeeting,
        //     },
        // ],
    },
    {
        oldVersioningPastSixMonthLimit: true,
        // Version 35: Adding Message Extension flyout to Add-ins group in Home and Read tabs
        // addControl: [
        //     {
        //         tabVariableName: 'homeTab',
        //         groupId: MailRibbonGroupId.Group_AddIns,
        //         controlId: ActionControlId.GetMessageExtensions,
        //     },
        // ],
        // updateGroupOrdering: [
        //     {
        //         tabVariableName: 'homeTab',
        //         newStaticGroupIdOrdering: [
        //             MailRibbonGroupId.Group_Move_and_Delete,
        //             MailRibbonGroupId.Group_SpamAddins,
        //             MailRibbonGroupId.Group_Respond,
        //             MailRibbonGroupId.Group_Teams_Chat,
        //             MailRibbonGroupId.Group_Tracking_Home,
        //             MailRibbonGroupId.Group_Tags,
        //             MailRibbonGroupId.Group_Undo,
        //             MailRibbonGroupId.Group_Print,
        //             MailRibbonGroupId.Group_AddIns,
        //             MailRibbonGroupId.Group_Find,
        //         ],
        //     },
        // ],
    },
    {
        oldVersioningPastSixMonthLimit: true,
        // Version 36: Move folder pane controls to the view tab from the layout menu in SLR
        // addControl: [
        //     {
        //         tabVariableName: 'viewTab',
        //         groupId: MailRibbonGroupId.Group_View_Layout,
        //         controlId: MailRibbonControlId.FolderPane,
        //     },
        // ],
    },
    {
        oldVersioningPastSixMonthLimit: true,
        // Version 37: Move report control from move and delete group to Group_SpamAddins in SLR
        // removeControl: [
        //     {
        //         tabVariableName: 'homeTab',
        //         controlId: MailRibbonControlId.ReportSplit,
        //     },
        // ],
        // addControl: [
        //     {
        //         tabVariableName: 'homeTab',
        //         groupId: MailRibbonGroupId.Group_SpamAddins,
        //         controlId: MailRibbonControlId.ReportSplit,
        //     },
        // ],
    },
    {
        oldVersioningPastSixMonthLimit: true,
        // Version 38: Move report control from Group_SpamAddins to Group_Report in SLR
        // removeControl: [
        //     {
        //         tabVariableName: 'homeTab',
        //         controlId: MailRibbonControlId.ReportSplit,
        //     },
        // ],
        // addGroup: [
        //     {
        //         tabVariableName: 'homeTab',
        //         groupDefinition: {
        //             groupId: MailRibbonGroupId.Group_Report,
        //             groupName: undefined,
        //             controlIds: [MailRibbonControlId.ReportSplit],
        //             hasOwnOverflow: false,
        //         },
        //     },
        // ],
        // updateGroupOrdering: [
        //     {
        //         tabVariableName: 'homeTab',
        //         newStaticGroupIdOrdering: [
        //             MailRibbonGroupId.Group_Move_and_Delete,
        //             MailRibbonGroupId.Group_Report,
        //             MailRibbonGroupId.Group_SpamAddins,
        //             MailRibbonGroupId.Group_Respond,
        //             MailRibbonGroupId.Group_Teams_Chat,
        //             MailRibbonGroupId.Group_Tracking_Home,
        //             MailRibbonGroupId.Group_Tags,
        //             MailRibbonGroupId.Group_Undo,
        //             MailRibbonGroupId.Group_Print,
        //             MailRibbonGroupId.Group_AddIns,
        //             MailRibbonGroupId.Group_Find,
        //         ],
        //     },
        // ],
    },
    {
        oldVersioningPastSixMonthLimit: true,
        // Version 39 previously added a third-party chat group; removed as part of deprecation cleanup
        // addControl: [
        //     {
        //         tabVariableName: 'homeTab',
        //         groupId: MailRibbonGroupId.Group_ThirdPartyIMChat_DEPRECATED,
        //         controlId: MailRibbonControlId.ThirdPartyIMChat_DEPRECATED,
        //     },
        // ],
        // addGroup: [
        //     {
        //         tabVariableName: 'homeTab',
        //         groupDefinition: {
        //             groupId: MailRibbonGroupId.Group_ThirdPartyIMChat_DEPRECATED,
        //             groupName: undefined,
        //             controlIds: [MailRibbonControlId.ThirdPartyIMChat_DEPRECATED],
        //             hasOwnOverflow: false,
        //         },
        //     },
        // ],
        // updateGroupOrdering: [
        //     {
        //         tabVariableName: 'homeTab',
        //         newStaticGroupIdOrdering: [
        //             MailRibbonGroupId.Group_Move_and_Delete,
        //             MailRibbonGroupId.Group_SpamAddins,
        //             MailRibbonGroupId.Group_Respond,
        //             MailRibbonGroupId.Group_Teams_Chat,
        //             MailRibbonGroupId.Group_ThirdPartyIMChat_DEPRECATED,
        //             MailRibbonGroupId.Group_Tracking_Home,
        //             MailRibbonGroupId.Group_Tags,
        //             MailRibbonGroupId.Group_Undo,
        //             MailRibbonGroupId.Group_Print,
        //             MailRibbonGroupId.Group_Find,
        //             MailRibbonGroupId.Group_AddIns,
        //             MailRibbonGroupId.Group_CommsCopilot,
        //         ],
        //     },
        // ],
    },
    {
        oldVersioningPastSixMonthLimit: true,
        // Version 40: Add "Light RP" to ribbon
        // addControl: [
        //     {
        //         tabVariableName: 'viewTab',
        //         groupId: MailRibbonGroupId.Group_View_Messages,
        //         controlId: MailRibbonControlId.LightRP,
        //     },
        // ],
    },
    {
        oldVersioningPastSixMonthLimit: true,
        // Version 41: Remove duplicated report group in SLR
        // removeControl: [
        //     {
        //         tabVariableName: 'homeTab',
        //         controlId: MailRibbonControlId.ReportSplit,
        //     },
        // ],
        // removeGroup: [
        //     {
        //         tabVariableName: 'homeTab',
        //         groupId: MailRibbonGroupId.Group_Report,
        //     },
        // ],
        // addControl: [
        //     {
        //         tabVariableName: 'homeTab',
        //         groupId: MailRibbonGroupId.Group_Move_and_Delete,
        //         controlId: MailRibbonControlId.ReportSplit,
        //     },
        // ],
    },
    {
        oldVersioningPastSixMonthLimit: true,
        // Version 42: Update Chat Around Email group setting
        // removeControl: [
        //     {
        //         tabVariableName: 'homeTab',
        //         controlId: MailRibbonControlId.Teams_ChatAroundEmail,
        //     },
        // ],
        // addControl: [
        //     {
        //         tabVariableName: 'homeTab',
        //         groupId: MailRibbonGroupId.Group_Teams_Chat,
        //         controlId: MailRibbonControlId.Teams_ChatAroundEmailFlyout,
        //     },
        // ],
    },
    {
        oldVersioningPastSixMonthLimit: true,
        // Version 43: third-party chat group; removed as part of deprecation cleanup
        // removeGroup: [
        //     {
        //         tabVariableName: 'homeTab',
        //         groupId: MailRibbonGroupId.Group_ThirdPartyIMChat_DEPRECATED,
        //     },
        // ],
        // removeControl: [
        //     {
        //         tabVariableName: 'homeTab',
        //         controlId: MailRibbonControlId.ThirdPartyIMChat_DEPRECATED,
        //     },
        // ],
    },
    {
        oldVersioningPastSixMonthLimit: true,
        //Version 44: Adds Search Tab, Search Group, and Search Controls to the Ribbon
        // this updated a non-customizable tab and has been removed to prevent copying
    },
    {
        oldVersioningPastSixMonthLimit: true,
        // Version 45: Introduce CopilotReplyWithMeetingFlyout split button while RETAINING
        // the standalone CopilotReplyWithMeeting and ReplyWithMeeting buttons. This ensures
        // that when the 'cal-copilot-schedule-from-email-bizchat' flight is OFF, users continue to
        // see the previous two separate buttons outside of the flyout. When the flight is ON,
        // UI logic will hide the standalone controls in favor of the flyout split button.
        // addControl: [
        //     {
        //         tabVariableName: 'homeTab',
        //         groupId: MailRibbonGroupId.Group_Respond,
        //         controlId: MailRibbonControlId.CopilotReplyWithMeetingFlyout,
        //     },
        // ],
        // addControlToOverflow: [
        //     {
        //         tabVariableName: 'homeTab',
        //         controlId: MailRibbonControlId.CopilotReplyWithMeetingFlyout,
        //     },
        // ],
    },
    {
    // Version 46: Add dedicated Mail Merge tab with data management and preview controls.
    // this updated a non-customizable tab and has been removed to prevent copying
    },
    {
    // Version 47: Add Search Highlighting toggle to the Search Tools group
    // this updated a non-customizable tab and has been removed to prevent copying
    },
    {
        // Version 48: Move Restore/Restore All out of the Delete groups and into their own group for MLR
        // and add them into a group with New Message control for SLR
        
        removeControl: [
            {
                tabVariableName: "homeTab",
                controlId: 683,
            },
            {
                tabVariableName: "homeTab",
                controlId: 684,
            },
            {
                tabVariableName: "homeTab",
                controlId: 587,
                ribbonSurface: "singleline",
            },
        ],
        addGroup: [
            {
                tabVariableName: "homeTab",
                groupDefinition: {
                    groupId: 216,
                    groupName: undefined,
                    controlIds: [683, 684],
                    hasOwnOverflow: false,
                },
                ribbonSurface: "multiline",
            },
            {
                tabVariableName: "homeTab",
                groupDefinition: {
                    groupId: 116,
                    groupName: undefined,
                    controlIds: [
                        587,
                        683,
                        684,
                    ],
                    hasOwnOverflow: false,
                },
                ribbonSurface: "singleline",
            },
        ],
        updateGroupOrdering: [
            {
                tabVariableName: "homeTab",
                newStaticGroupIdOrdering: [
                    116,
                    216,
                    104,
                    197,
                    192,
                    121,
                    198,
                    195,
                    113,
                    120,
                    128,
                    118,
                    101,
                    108,
                    130,
                ],
                ribbonSurface: "multiline",
            },
            {
                tabVariableName: "homeTab",
                newStaticGroupIdOrdering: [
                    116,
                    114,
                    192,
                    121,
                    198,
                    195,
                    128,
                    130,
                    118,
                    101,
                    108,
                ],
                ribbonSurface: "singleline",
            },
        ],
    },
    // IMPORTANT! The only tabs that require versioning are customizable tabs
    // If your ribbon updates do not impact customizable tabs (Mail Home & Mail View for now)
    // then DO NOT add a version upgrade here
    //
    // Are your changes updating the SLR and MLR layouts differently? If so, you must add the new
    // ribbonSurface parameter to the versioning object
    //
    // Example:
    //
    // addControl: [
    //     {
    //         tabVariableName: 'viewTab',
    //         groupId: MailRibbonGroupId.Group_View_Messages,
    //         controlId: MailRibbonControlId.Messages,
    //         ribbonSurface: 'singleline',
    //     },
    //     {
    //         tabVariableName: 'viewTab',
    //         groupId: MailRibbonGroupId.Group_View_Settings,
    //         controlId: MailRibbonControlId.Messages,
    //         ribbonSurface: 'multiline',
    //     },
    // ],
];
